import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#D9D9D9",
      d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10l-.001-.001V22l-.003-.001C6.475 21.997 2 17.522 2 12S6.477 2 12 2M8.936 12.75c.074 2.175.47 4.1 1.05 5.504.324.783.691 1.368 1.06 1.745.366.374.687.5.952.5h.001c.265 0 .588-.126.954-.5.37-.377.736-.962 1.06-1.745.58-1.403.976-3.33 1.05-5.504zm-5.4 0a8.5 8.5 0 0 0 5.662 7.275 9 9 0 0 1-.598-1.198c-.668-1.614-1.09-3.742-1.164-6.077zm13.028 0c-.076 2.335-.497 4.463-1.165 6.077-.178.431-.379.834-.6 1.198a8.5 8.5 0 0 0 5.666-7.275zM14.8 3.974c.22.364.42.767.6 1.199.667 1.614 1.088 3.742 1.164 6.077h3.9A8.5 8.5 0 0 0 14.8 3.974m-5.602 0a8.5 8.5 0 0 0-5.663 7.276h3.9c.076-2.335.497-4.463 1.165-6.077a9 9 0 0 1 .598-1.2M12 3.5c-.265 0-.587.127-.953.501-.369.377-.736.962-1.06 1.745-.58 1.403-.976 3.33-1.05 5.504h6.127c-.074-2.175-.47-4.1-1.05-5.504-.324-.783-.69-1.368-1.06-1.745-.366-.374-.689-.501-.954-.501"
    }, null, -1)
  ]))]))
}
export default { render: render }